<div padding>
  <rt-box layout-vertical class="skeleton-field" margin-bottom>
    <rt-placeloader variant="item" class="skeleton-field__label" style="width: 45%" />
    <rt-placeloader variant="item" class="skeleton-field__control" />
  </rt-box>

  <rt-box layout-vertical class="skeleton-field" margin-bottom>
    <rt-placeloader variant="item" class="skeleton-field__label" style="width: 60%" />
    <rt-placeloader variant="item" class="skeleton-field__control skeleton-field__control--tall" />
  </rt-box>

  <rt-box layout-vertical class="skeleton-field" margin-bottom>
    <rt-placeloader variant="item" class="skeleton-field__label" style="width: 38%" />
    <div class="skeleton-field__row">
      <rt-placeloader variant="item" class="skeleton-field__chip" />
      <rt-placeloader variant="item" class="skeleton-field__chip" />
      <rt-placeloader variant="item" class="skeleton-field__chip" />
      <rt-placeloader variant="item" class="skeleton-field__chip" />
    </div>
  </rt-box>

  <rt-box layout-vertical class="skeleton-field">
    <rt-placeloader variant="item" class="skeleton-field__label" style="width: 30%" />
    <rt-placeloader variant="item" class="skeleton-field__control" />
  </rt-box>
</div>
